import React, { Component } from 'react'
import {BrowserRouter} from 'react-router-dom'
import Toolbar from '../Navigation/Toolbar/Toolbar'
import classes from './Layout.module.css'
import Footer from '../Footer/Footer'
import Sidebar from '../../Components/Navigation/Sidebar/Sidebar'
import { withRouter } from 'react-router-dom'
import Home from '../../Containers/Home/Home'
import {Route} from 'react-router-dom'
import Register from '../../Containers/Register/Register';
import Login from '../../Containers/Login/Login'
import {connect} from 'react-redux'
import StudyMaterial from '../../Containers/StudyMaterial/StudyMaterial';
import BillingPage from '../../Containers/BillingPage/BillingPage'
 

class Layout extends Component  {
    state={
        showSideBar:false
    }
    BackdropCloseHandler=()=>{
        this.setState({showSideBar:false})
    }
    SideBarToggle=()=>{
    this.setState((prevState)=>{
     return {showSideBar:!prevState.showSideBar}
    })
}
    render(){
       let toolbar = null
      console.log(this.props.location.pathname)
       if((this.props.location.pathname==="/login") || this.props.location.pathname==="/register"){
        toolbar=null
       }
       else{
        toolbar=
        <Toolbar ToggleSidebar={this.SideBarToggle}/>   
       }
    return (
        <div className = {classes.body}>
             <Sidebar show = {this.state.showSideBar} ModalClosed={this.BackdropCloseHandler}/>
         {toolbar} 
            <main  >
               <BrowserRouter>
                 <Route path='/' exact component={Home}></Route>
                 <Route path='/register' exact component={Register}></Route>
                 <Route path='/login' exact component={Login}></Route>
                 <Route path='/course-material' exact component={StudyMaterial}></Route>
                 <Route path='/billing-page' exact component = {BillingPage}></Route>
               </BrowserRouter>
            </main>
              {/* <Footer/>  */}
        </div>
    )
    }
}
export default withRouter(Layout)
